import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-confirm',
  template: `
  <h1 matDialogTitle fxLayoutAlign="center" class="mb-05" style="padding-bottom:10px !important;text-align: center !important;">{{ data.title|translate }}</h1>
  <p mat-dialog-content [innerHTML]="data.message|translate" class="mb-1"></p>
  <div mat-dialog-actions>
  <button *ngIf="this.data.confirmType" type="button" mat-raised-button
      color="primary" (click)="dialogRef.close(true)">{{'general.accept'|translate}}
  </button>
  <button *ngIf="this.data.question" type="button" mat-raised-button
      color="primary" (click)="dialogRef.close(true)">{{'general.yes'|translate}}
  </button>
  <button *ngIf="!this.data.confirmType && !this.data.question" type="button" mat-raised-button
      color="primary" (click)="dialogRef.close(true)">{{'general.ok'|translate}}
  </button>
  &nbsp;
  <span fxFlex></span>
  <button type="button" color="warn" mat-raised-button *ngIf="this.data.confirmType"
        (click)="dialogRef.close(false)">{{'general.cancel'|translate}}
  </button>
  <button type="button" color="warn" mat-raised-button *ngIf="this.data.question"
        (click)="dialogRef.close(false)">{{'general.no'|translate}}
  </button>
  </div>`,
})
export class AppComfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<AppComfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
}